module.exports = __webpack_public_path__ + "img/merch-light.5b769495.jpg";